"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ZoomInSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.41,26.59l-7.35-7.36a11,11,0,1,0-2.83,2.83l7.36,7.35a2,2,0,0,0,2.82-2.82ZM13,20a7,7,0,1,1,7-7A7,7,0,0,1,13,20Z"/><path d="M17,14H14v3a1,1,0,0,1-1.69.7A1,1,0,0,1,12,17V14H9a1,1,0,0,1-.7-.29A1,1,0,0,1,9,12h3V9a1,1,0,0,1,2,0v3h3a1,1,0,0,1,0,2Z"/>';
var ZoomInSVG = function ZoomInSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ZoomInSVG = ZoomInSVG;
ZoomInSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ZoomInSVG);
exports.default = _default;